import { ConfigsService, LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AccountService, ModalService, REDIRECTIONS } from '@sm360/widget-commons-general';

import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';

import 'commons-vehicle/Vehicle/components/CallToAction/VehicleCtaBar/VehicleCtaBar.scss';

class BuyOnlineCTAV25 {
    constructor() {
        this.quote = null;

        this.buyOnline = this.buyOnline.bind(this);
        this.onBuyOnline = this.onBuyOnline.bind(this);
        this.saveQuote = this.saveQuote.bind(this);
        this.isQuoteInGarage = this.isQuoteInGarage.bind(this);
    }

    onBuyOnline(quoteId) {
        if (!quoteId) return;

        if (AccountService.isAuthenticated()) {
            this.isQuoteInGarage(quoteId).then((isInGarage) => {
                if (isInGarage) {
                    ShowroomService.loadQuote(quoteId).then((quote) => {
                        this.quote = quote;
                        this.saveQuote();
                    });
                } else {
                    ShowroomService.loadQuoteV25(quoteId).then((quote) => {
                        this.quote = quote;
                        this.saveQuote();
                    });
                }
            });
        } else {
            ShowroomService.loadQuoteV25(quoteId).then((quote) => {
                this.quote = quote;
                const LoginModalBuyOnline = ModalService.get('login/SignUpModal');
                LoginModalBuyOnline.addCallbacks({
                    onClose: this.buyOnline,
                });
                LoginModalBuyOnline.open();
            });
        }
    }

    buyOnline() {
        if (AccountService.isAuthenticated()) {
            this.saveQuote();
        }
        return true;
    }

    saveQuote() {
        const locale = LocaleService.getSimpleLocale();
        const url = REDIRECTIONS[locale].checkout;
        const mappedQuote = this.quote.getShowroomQuote();

        return ShowroomService.saveQuote(mappedQuote).then((showroomQuote) => {
            const windowProxy = WindowProxy.get();

            if (windowProxy) {
                const newQuote = QuoteService.resetQuoteFromShowroomSave(this.quote, showroomQuote);
                const historyUrl = newQuote.buildUrl(windowProxy.location.href);

                windowProxy.history.replaceState(
                    {
                        quote: mappedQuote,
                    },
                    'tradeIn',
                    historyUrl
                );

                const fullUrl = newQuote.buildUrl(url);

                if (ConfigsService.isInMobileApp() && !AccountService.isAuthenticated()) {
                    windowProxy.location.href =
                        `ca.solutionsmedias360.showroom-${ConfigsService.getWebsiteId()}://` +
                        `?action=login&redirectUrl=${encodeURIComponent(fullUrl)}`;
                } else {
                    windowProxy.location.href = fullUrl;
                }
            }
        });
    }

    isQuoteInGarage(quoteId) {
        let response = false;
        if (!AccountService.isAuthenticated()) return response;
        return ShowroomService.loadQuotes().then((res) => {
            if (res && res.length > 0) {
                res.forEach((e) => {
                    if (e.id === quoteId) response = true;
                });
            }
            return response;
        });
    }
}

export default BuyOnlineCTAV25;



// WEBPACK FOOTER //
// ./src/Vehicle/components/CallToAction/BuyOnlineV25/BuyOnlineCTAV25.jsx